import { render, staticRenderFns } from "./PostClass.vue?vue&type=template&id=5b980114&scoped=true&"
import script from "./PostClass.vue?vue&type=script&lang=js&"
export * from "./PostClass.vue?vue&type=script&lang=js&"
import style0 from "./PostClass.vue?vue&type=style&index=0&id=5b980114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b980114",
  null
  
)

export default component.exports